import React from 'react';
import styles from './AdminPagination.module.css';

const PAGE_SIZES = [10, 25, 50, 100];

export default function AdminPagination({ page, pageSize, total, onPageChange, onPageSizeChange }) {
  if (total === 0) return null;

  const pages = Math.max(1, Math.ceil(total / pageSize));
  const currentPage = Math.min(page, pages);
  const firstItem = (currentPage - 1) * pageSize + 1;
  const lastItem = Math.min(currentPage * pageSize, total);

  return (
    <div className={styles.pagination} aria-label="Table pagination">
      <span className={styles.range}>
        Showing {firstItem}–{lastItem} of {total}
      </span>
      <div className={styles.controls}>
        <label className={styles.pageSizeLabel}>
          Rows per page
          <select
            className={styles.pageSizeSelect}
            value={pageSize}
            onChange={event => onPageSizeChange(Number(event.target.value))}
          >
            {PAGE_SIZES.map(size => (
              <option key={size} value={size}>{size}</option>
            ))}
          </select>
        </label>
        <button
          className={styles.pageButton}
          type="button"
          aria-label="Previous page"
          disabled={currentPage === 1}
          onClick={() => onPageChange(currentPage - 1)}
        >
          Previous
        </button>
        <span className={styles.pageInfo}>Page {currentPage} of {pages}</span>
        <button
          className={styles.pageButton}
          type="button"
          aria-label="Next page"
          disabled={currentPage === pages}
          onClick={() => onPageChange(currentPage + 1)}
        >
          Next
        </button>
      </div>
    </div>
  );
}
